import { Link } from 'react-router-dom';
import { rankingCards } from '../../../mocks/ranking-cards';

export default function ConfusedPick() {
  const recommendedCard = rankingCards[0];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 relative overflow-hidden">
      {/* 装飾要素 */}
      <div className="absolute top-10 right-10 w-64 h-64 bg-gradient-to-br from-amber-200/50 to-orange-200/50 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-80 h-80 bg-gradient-to-tr from-yellow-200/40 to-amber-200/40 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        {/* ヘッダー */}
        <div className="text-center mb-8 sm:mb-12">
          <span className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs sm:text-sm font-bold px-4 sm:px-5 py-2 sm:py-2.5 rounded-full shadow-lg shadow-amber-500/25 mb-3 sm:mb-4">
            <i className="ri-lightbulb-flash-line text-base sm:text-lg"></i>
            迷ったらコレ！
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 tracking-tight px-4">
            迷ったらこのカードがおすすめ
          </h2>
          <p className="text-base sm:text-lg text-gray-600 px-4">
            初心者からベテランまで、万人におすすめできる1枚
          </p>
        </div>

        {/* カード */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-2xl overflow-hidden border-2 border-amber-200/50">
          {/* ヘッダーバー */}
          <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white text-center py-3 sm:py-4">
            <div className="flex items-center justify-center gap-2">
              <i className="ri-medal-2-fill text-xl sm:text-2xl"></i>
              <span className="font-bold text-base sm:text-lg">総合満足度No.1</span>
            </div>
          </div>
          
          <div className="p-6 sm:p-8 md:p-12">
            <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-10">
              {/* カード画像 */}
              <div className="relative flex-shrink-0 w-full sm:w-auto">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-100 to-orange-100 rounded-2xl sm:rounded-3xl blur-xl opacity-60"></div>
                <div className="relative w-full sm:w-64 h-36 sm:h-40 bg-gradient-to-br from-white to-gray-50 rounded-2xl p-5 sm:p-6 flex items-center justify-center shadow-xl border border-gray-100">
                  <img
                    src={recommendedCard.logo}
                    alt={recommendedCard.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              {/* カード情報 */}
              <div className="flex-1 w-full">
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-5 sm:mb-6 text-center lg:text-left">
                  <Link to={recommendedCard.detailUrl} className="hover:text-teal-600 hover:underline transition-colors cursor-pointer">
                    {recommendedCard.name}
                  </Link>
                </h3>
                
                {/* スペック */}
                <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
                  <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl sm:rounded-2xl p-4 sm:p-5 text-center border border-teal-100">
                    <p className="text-xs text-gray-500 mb-1 sm:mb-2 font-medium">還元率</p>
                    <p className="text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">{recommendedCard.returnRate}</p>
                  </div>
                  <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl sm:rounded-2xl p-4 sm:p-5 text-center border border-emerald-100">
                    <p className="text-xs text-gray-500 mb-1 sm:mb-2 font-medium">年会費</p>
                    <p className="text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-teal-600">{recommendedCard.annualFee}</p>
                  </div>
                </div>

                {/* メリット */}
                <div className="space-y-3 mb-6 sm:mb-8">
                  {recommendedCard.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-start gap-2 sm:gap-3 bg-gradient-to-r from-amber-50/80 to-orange-50/80 p-3 sm:p-4 rounded-xl border border-amber-100/50">
                      <div className="w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                      </div>
                      <p className="text-gray-700 font-medium text-sm sm:text-base">{benefit}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTAボタン */}
              <div className="flex flex-col gap-3 sm:gap-4 w-full lg:w-auto">
                <a
                  href={recommendedCard.officialUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold px-8 sm:px-10 py-4 sm:py-5 rounded-xl sm:rounded-2xl transition-all shadow-xl shadow-orange-500/30 hover:shadow-2xl hover:shadow-orange-500/40 transform hover:scale-105 whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  <i className="ri-external-link-line text-lg sm:text-xl"></i>
                  今すぐ申し込む
                </a>
                <a
                  href={recommendedCard.detailUrl}
                  className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-700 font-semibold px-8 sm:px-10 py-3 sm:py-4 rounded-xl sm:rounded-2xl border-2 border-gray-200 hover:border-amber-300 transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  詳細を見る
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}